import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { comoFunciona } from '../data/content';
export function Solution() {
  return <section className="w-full border-y border-surface-line bg-surface-alt" aria-labelledby="solucion-titulo" data-id="element-171" data-mp="1emf8c9dvkqbr">
      <div className="mx-auto max-w-6xl px-5 py-10 sm:px-6 sm:py-16" data-id="element-172" data-mp="15rr32j8av8my">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center lg:gap-14" data-id="element-173" data-mp="quzylvjrr6qh">
          <div className="text-center lg:text-left" data-id="element-174" data-mp="qxcqb0fbwvgq">
            <h2 id="solucion-titulo" className="font-display text-[1.6rem] leading-[1.05] text-ink-strong sm:text-4xl" data-id="element-175" data-mp="vv5xnwsdbvil">
              Host Automático™ es el sistema operativo de tu Airbnb
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-ink sm:text-base" data-id="element-176" data-mp="mv9bc1tgb8qp">
              No es un curso. No son videos eternos. No es teoría genérica.
            </p>
            <p className="mt-2 text-sm leading-relaxed text-ink sm:text-base" data-id="element-177" data-mp="2h6xkfnd04h36">
              Es una biblioteca práctica en PDF con mensajes, checklists,
              protocolos y guías listas para aplicar en tu alojamiento desde
              hoy.
            </p>
            <div className="mt-6 sm:mx-auto sm:max-w-sm lg:mx-0" data-id="element-178" data-mp="gqthzoyvc4df">
              <CTAButton label="Quiero dejar de improvisar" fullWidth data-id="element-179" data-mp="brgx39rk57dh" />
            </div>
          </div>

          <ul className="grid grid-cols-2 gap-2 sm:gap-3" data-id="element-180" data-mp="3k7afju5g8sx6">
            {comoFunciona.map(paso => <li key={paso} className="flex items-center gap-2 rounded-lg border border-surface-line bg-white px-3 py-3" data-id="element-181" data-mp="3g5yjp6vzfbgj">
                <CheckIcon className="h-4 w-4 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-182" data-mp="3u3dfqugqqhhh" />
                <span className="text-[13px] font-bold text-ink-strong sm:text-sm" data-id="element-183" data-mp="19do04f87qrnq">
                  {paso}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}